var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoFrame(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 343,
    height: 343,
    viewBox: "0 0 343 343",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M164.626 163.805L178.38 1H120.055L107.518 149.392L164.626 163.805ZM164.626 163.805H120.178C112.541 163.805 106.846 157.415 107.518 149.392L164.626 163.805Z",
    stroke: "#F88D2C",
    strokeOpacity: 0.5,
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.584 103.344H96.5217L91.4132 163.805H7.43025L11.3083 117.925L11.3083 117.924C11.9851 109.846 18.8713 103.344 26.584 103.344Z",
    stroke: "#F88D2C",
    strokeOpacity: 0.5,
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M98.5867 254.978L92.4493 327.587L98.5867 254.978ZM98.5867 254.978H156.912L149.558 342H105.109C97.4731 342 91.7774 335.599 92.4492 327.587L98.5867 254.978Z",
    stroke: "#F88D2C",
    strokeOpacity: 0.5,
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M250.366 15.4131L244.228 88.0224H185.903L193.257 1H237.706C245.342 1 251.038 7.40088 250.366 15.4125C250.366 15.4127 250.366 15.4129 250.366 15.4131Z",
    stroke: "#F88D2C",
    strokeOpacity: 0.5,
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M331.622 225.076L331.622 225.077C330.945 233.154 324.059 239.657 316.347 239.657H246.409L251.517 179.196H335.5L331.622 225.076Z",
    stroke: "#F88D2C",
    strokeOpacity: 0.5,
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M183.497 117.925L183.497 117.924C184.174 109.846 191.06 103.344 198.773 103.344H341.912L336.804 163.805H179.619L183.497 117.925Z",
    stroke: "#F88D2C",
    strokeOpacity: 0.5,
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M164.562 342L178.316 179.196H222.764C230.401 179.196 236.096 185.586 235.424 193.609L222.887 342H164.562Z",
    stroke: "#F88D2C",
    strokeOpacity: 0.5,
    strokeWidth: 2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M159.503 224.393L159.503 224.394C158.826 232.471 151.94 238.974 144.227 238.974H1.08805L6.19654 178.513H163.381L159.503 224.393Z",
    stroke: "#F88D2C",
    strokeOpacity: 0.5,
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFrame);
export default __webpack_public_path__ + "static/media/logo_frame.49c83f0301b6faefd374f8420693a50a.svg";
export { ForwardRef as ReactComponent };